<template>
  <main class="main page-inside text-page contact-us-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title regular">Contact us</div>
          <div class="content form-fields-wrapper">
            <label>
              <div class="desc">Name:</div>
              <input
                type="text"
                @input="validateLatin('name')"
                placeholder="Name"
                v-model="name"
              />
            </label>
            <label>
              <div class="desc">Email:</div>
              <input
                type="text"
                placeholder="Email"
                @input="validateLatin('email')"
                v-model="email"
              />
            </label>
            <label>
              <div class="desc">Message</div>
              <textarea
                placeholder="Message"
                @input="validateLatin('message')"
                v-model="message"
              ></textarea>
            </label>
            <div class="chekbox-container">
              <label class="chekbox-label">
                <div class="chekbox-label-wrapper">
                  <input type="checkbox" name="terms" v-model="terms" />
                  <div class="checkbox"></div>
                  <span class="desc">I agree to the websites </span>
                  <a @click="$parent.goToPrivacy()" class="desc">
                    Privacy Policy</a
                  >
                </div>
              </label>
            </div>
            <button
              class="button red long"
              :class="{ disabled: !terms }"
              @click="submit"
            >
              Send
            </button>
            <transition name="fade">
              <div v-if="$parent.successMessage" class="desc small green">
                {{ $parent.successMessage }}
              </div>
            </transition>
            <transition name="slide">
              <div v-if="$parent.error" class="error-desc desc red">
                {{ $parent.error }}
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "ContactUs",
  props: ["successMessage"],
  components: {},
  data: function () {
    return {
      name: "",
      email: "",
      message: "",
      terms: "",
    };
  },
  watch: {
    successMessage: function (newVal) {
      if (newVal.length) {
        this.name = "";
        this.email = "";
        this.message = "";
      }
    },
  },
  methods: {
    validateLatin(field) {
      this[field] = this[field].replace(/[^a-zA-Z0-9\s.,!@?]/g, "");
    },
    submit() {
      if (!this.terms) return;

      if (!this.name || !this.email || !this.message) {
        this.$parent.error = "Please fill in all fields.";
        return;
      }
      let data = {
        name: this.name,
        email: this.email,
        message: this.message,
      };
      this.$emit("sendContactForm", data);
    },
  },
};
</script>
